import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {AfriexProcessor} from '@/types';

import ProcessorFormModal from './ProcessorFormModal';

type ProcessorUpdateButtonProps = {
  initialData: AfriexProcessor;
};

const ProcessorUpdateButton = ({
  initialData,
}: ProcessorUpdateButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <ProcessorFormModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      initialData={initialData}
    />
  ) : (
    <Button variant="solid" colorScheme="cyan" onClick={toggleFullScreen}>
      Update Processor
    </Button>
  );
};

export default ProcessorUpdateButton;
